import React from 'react';
import styled from 'styled-components';

const LeaseSummaryColumn = styled.div`
  width: 100%;
  float: left;
`;

const LeaseSummaryColumnContent = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 1.2rem;
  margin: 3px 0 8px 0;
`;

export default function BaseLease({ selectedBaseDocumentTemplate }) {
  return (
    <LeaseSummaryColumn>
      <LeaseSummaryColumnContent>{selectedBaseDocumentTemplate.label}</LeaseSummaryColumnContent>
    </LeaseSummaryColumn>
  );
}
